// extracted by mini-css-extract-plugin
export default {"sec_heading":"RelatedImages_sec_heading__v6EsD"};